import { lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import * as wheelSelector from "redux/landing/wheels/selectors";
import { WheelType } from "types/Wheel";

const LazyGirlsElements = lazy(
  () => import("components/molecules/GirlsElements"),
);

const LazyGirlsElementsBangladesh = lazy(
  () => import("components/molecules/GirlsElementsBangladesh"),
);

const LazyTeenagersElements = lazy(
  () => import("components/molecules/TeenagersElements"),
);

const LazyCardsElements = lazy(
  () => import("components/molecules/CardsElements"),
);

const LazyAviatorElements = lazy(
  () => import("components/molecules/AviatorElements"),
);

const LazyCrazyTimeElements = lazy(
  () => import("components/molecules/CrazyTimeElements"),
);

const LazyChicksElements = lazy(
  () => import("components/molecules/ChicksElements"),
);

const LazyRouletteElements = lazy(
  () => import("components/molecules/RouletteElements"),
);

const LazyBonanzaElements = lazy(
  () => import("components/molecules/BonanzaElements"),
);

const LazyOlympusElements = lazy(
  () => import("components/molecules/OlympusElements"),
);

const WheelDesignContainer = () => {
  const { type } = useSelector(wheelSelector.all);
  return (
    <>
      {type === WheelType.GIRLS_BANGLADESH && (
        <Suspense fallback="">
          <LazyGirlsElementsBangladesh />
        </Suspense>
      )}
      {type === WheelType.GIRLS && (
        <Suspense fallback="">
          <LazyGirlsElements />
        </Suspense>
      )}
      {type === WheelType.TEENAGERS && (
        <Suspense fallback="">
          <LazyTeenagersElements />
        </Suspense>
      )}
      {type === WheelType.CARDS && (
        <Suspense fallback="">
          <LazyCardsElements />
        </Suspense>
      )}
      {type === WheelType.AVIATOR && (
        <Suspense fallback="">
          <LazyAviatorElements />
        </Suspense>
      )}
      {type === WheelType.CRAZY_TIME && (
        <Suspense fallback="">
          <LazyCrazyTimeElements />
        </Suspense>
      )}
      {(type === WheelType.CHICKS_TURKEY ||
        type === WheelType.CHICKS_BANGLADESH ||
        type === WheelType.CHICKS_AZER ||
        type === WheelType.CHICKS_UZBEKISTAN) && (
        <Suspense fallback="">
          <LazyChicksElements type={type} />
        </Suspense>
      )}
      {type === WheelType.ROULETTE && (
        <Suspense fallback="">
          <LazyRouletteElements />
        </Suspense>
      )}
      {type === WheelType.SWEET_BONANZA && (
        <Suspense fallback="">
          <LazyBonanzaElements />
        </Suspense>
      )}
      {type === WheelType.GATES_OLYMPUS && (
        <Suspense fallback="">
          <LazyOlympusElements />
        </Suspense>
      )}
    </>
  );
};

export default WheelDesignContainer;
